import {hideElem} from '../../../../js/utils/dom.ts';

export function hideSAMLElems() {
  hideElem('.saml');
  for (const input of document.querySelectorAll<HTMLInputElement>('.saml input[required]')) {
    input.removeAttribute('required');
  }
}
